import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';

let url = wixLocation.url;

console.log("url---cons")
console.log(url)

$w.onReady(function () {
    // let checkIfCurrentPageIsBlogPost = url.slice(0, 34);

    // if (checkIfCurrentPageIsBlogPost === "https://www.wix.com/partners/post/") {
    //     console.log("post-page")
    //     $w("#startNowNav").hide()
    //     $w("#menuToggle").hide()
    // } else {
    //     $w("#startNowNav").show()
    //     $w("#menuToggle").show()

    // }
});

const biLogger = biLoggerFactory('lp', 19, { msid: '36cb71f4-1b02-444c-918b-89f13279c1d2' });

async function fireEvent(buttonName) {
    try {
        const biEventObject = {
            evid: 703,
            button_name: buttonName,
            is_valid: true,
            topic: 'wix partners site',
            url: wixLocation.url
        };
        await biLogger.log(biEventObject);
    } catch (error) {
        console.log(error, "sth went wrong")
    }
}

export async function partnerProgram_click(event) {
    const biEventObject = {
        evid: 703,
        button_name: 'partners hp',
        is_valid: true,
        topic: 'wix partners site',
        url: wixLocation.url
    };
    await biLogger.log(biEventObject);
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function startNowNav_click(event) {
    fireLetsTalkEvent("Let’s Talk")
}

async function fireLetsTalkEvent(button) {
    try {
        const biEventObject = {
            evid: 703,
            button_name: button,
            is_valid: true,
            topic: "partners site",
            url: wixLocation.url,
            Additional_info: "Partners site HP header"
        };
        await biLogger.log(biEventObject);
    } catch (error) {
        console.log(error, "sth went wrong")
    }
}